import React from 'react';
import { cn } from '../../lib/utils/utils';

const CardLayout = ({ children, alarmed, className }) => {
	return (
		<div
			className={cn(`bg-darkaccent/60 text-white  rounded-md border-[1px] border-gray-800/40 shadow-2xl p-2 w-full`,` ${
				alarmed ? ' animate-warning ' : ''}`, className)
			}
		>
			{children}
		</div>
	);
};

export default CardLayout;
